module.exports = __webpack_public_path__ + "img/google-play.14fc0bda.png";